<template>
  <v-row justify="center" align="center">
    <v-dialog v-model="show">
      <v-card>
        <v-card-title v-if="title">
          <h2>{{ title }}</h2>
        </v-card-title>
        <v-card-text>
          <component v-on="$listeners"
                     :key="guid"
                     :is="form"
                     @crud:success="success"
                     @snackbar="openSnackbar"
                     @alert="openAlert" />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="alert.show" max-width="350">
      <v-card>
        <v-card-title class="headline">{{ alert.heading }}</v-card-title>
        <v-card-text>{{ alert.msg }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="accent"
                 text
                 @click="alert.show = false">
            Got It
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar.show" :timeout="-1">
      {{ snackbar.msg }}
      <v-btn color="accent" text @click="snackbar.show = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-row>
</template>

<script>
/**
 * Opens any registered Form Component in a dialog view
 *
 * There are similarities between this component and the CrudForm layout
 * It captures any messaging from any forms contained within via Snackbar or Alert events
 * It also renders any form dynamically through name alone
 *
 * The main difference is that the way in which Vue calculates its own internal state requires us to
 * manually handle the form's key so that forms can be properly cleared when needed
 */
import Messages from '@/components/Mixins/Messages';

export default {
  name: 'NestedForm',
  model: {
    prop: 'value',
    event: 'update',
  },
  mixins: [
    Messages,
  ],
  props: {
    form: {
      type: String,
      required: true,
    },
    title: String,
    value: [String, Number, Boolean, Object],
  },
  data() {
    return {
      show: false,
      guid: null,
    };
  },
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
    success(response) {
      this.$emit('update', response.data);
      this.close();
      this.guid = this.genguid(); // Resets the form
    },
    genguid() {
      // Not a real guid, but it'll do
      return `${this._uid}_${Date.now()}`;
    },
  },
  mounted() {
    this.guid = this.genguid();
  },
};
</script>
